import { Types } from "../actions/GeneralTableActions";

const initialState = {
    allRecords: {},
    plants: {},
    places: {},
    reasonGroups: {},
    mailGroups: {},
    mailPeriods: {},
    isTaskUpdated: false,
};

export const generalTableReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_ALL_LIST_FOR_GENERAL_TABLE:
            return {
                ...state,
                allRecords: action.payload || state.allRecords,
            };
        case Types.SET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE:
            return {
                ...state,
                places: action.payload || state.places,
            };
        case Types.SET_PLANTS_FOR_GENERAL_TABLE:
            return {
                ...state,
                plants: action.payload || state.plants,
            };
        case Types.SET_MAIL_GROUPS_FOR_GENERAL_TABLE:
            return {
                ...state,
                mailGroups: action.payload || state.mailGroups,
            };
        case Types.SET_MAIL_PERIODS_FOR_GENERAL_TABLE:
            return {
                ...state,
                mailPeriods: action.payload || state.mailPeriods,
            };
        case Types.SET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE:
            return {
                ...state,
                reasonGroups: action.payload || state.reasonGroups,
            };
        case Types.RESET_ALL_LIST_OF_GENERAL_TABLE:
            return {
                ...state,
                allRecords: {},
            };
        case Types.RESET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE:
            return {
                ...state,
                places: {},
            };
        case Types.RESET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE:
            return {
                ...state,
                reasonGroups: {},
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
